export type SearchFormPassengers = Pick<SearchFilters, 'seatbelts' | 'beds' | 'disabled_access' | 'pets'>
export const useSearchFiltersFormPassengers = (formRef: Ref<SearchFormPassengers> | undefined = undefined) => {
  const { filters } = storeToRefs(useSearchStore())

  const formPassengers = formRef === undefined
    ? ref<SearchFormPassengers>({
        seatbelts: null,
        beds: null,
        pets: false,
        disabled_access: false,
      })
    : formRef

  const showAdvancedPassengers = ref(false)

  const initFormPassengers = () => {
    formPassengers.value.seatbelts = filters.value.seatbelts
    formPassengers.value.beds = filters.value.beds
    formPassengers.value.disabled_access = filters.value.disabled_access
    formPassengers.value.pets = filters.value.pets
    if (formPassengers.value.seatbelts !== formPassengers.value.beds) {
      showAdvancedPassengers.value = true
    }
  }

  watch(() => formPassengers.value.seatbelts, (newValue) => {
    if (!showAdvancedPassengers.value) {
      formPassengers.value.beds = newValue
    }
  })

  watch(showAdvancedPassengers, (newValue) => {
    if (!newValue) {
      formPassengers.value.beds = formPassengers.value.seatbelts
    }
    else if (formPassengers.value.beds === null) {
      formPassengers.value.beds = formPassengers.value.seatbelts
    }
  })

  return {
    formPassengers,
    initFormPassengers,
    showAdvancedPassengers,
  }
}
